/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskGetDocumentsPathParameters } from 'api/actions/helpdesk-get-documents/helpdesk-get-documents-path-parameters';
import { HelpdeskGetDocumentsResponse } from 'api/actions/helpdesk-get-documents/helpdesk-get-documents-response';

type HelpdeskGetDocumentsQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskGetDocuments action.
 */
export const helpdeskGetDocumentsActionPath = new SweetPath<keyof HelpdeskGetDocumentsPathParameters>(
  '/help-desk/documents/',
  { path: '{param}' }
);

/**
 * Creates a contextualized HelpdeskGetDocuments actions.
 */
export default function createHelpdeskGetDocumentsAction(axios: AxiosInstance) {
  return function helpdeskGetDocumentsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HelpdeskGetDocumentsQueryParameters } = {}) {
    const path = helpdeskGetDocumentsActionPath.original;

    return axios.get<HelpdeskGetDocumentsResponse, HelpdeskGetDocumentsResponse>(path, { params: query, headers });
  };
}
